import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../../awsAuth";
import "./CreateCommunity.scss";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  "http://localhost:5000";

const CreateCommunity = ({ onClose, onCommunityCreated }) => {
  const { userId } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [avatar, setAvatar] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAvatar(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      alert("Спершу увійдіть в акаунт");
      return;
    }

    if (!name.trim()) {
      alert("Назва спільноти обовʼязкова");
      return;
    }

    if (!avatar) {
      alert("Виберіть аватарку");
      return;
    }

    try {
      setIsUploading(true);

      const token = await getAccessToken();
      if (!token) {
        throw new Error("Немає токена авторизації");
      }

      let avatarUrl = "";

      const formData = new FormData();
      formData.append("file", avatar);

      const uploadRes = await fetch(
        `${API_BASE}/api/communities/upload-avatar`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!uploadRes.ok) {
        const txt = await uploadRes.text().catch(() => "");
        throw new Error(txt || "Помилка завантаження аватарки");
      }

      const uploadData = await uploadRes.json();
      avatarUrl = uploadData.url;

      const res = await fetch(`${API_BASE}/api/communities`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          name,
          description,
          avatar: avatarUrl,
        }),
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(txt || "Помилка створення спільноти");
      }

      const data = await res.json();

      onCommunityCreated?.(data.communityId);
      onClose?.();
      navigate(`/communities/${data.communityId}`);
    } catch (err) {
      console.error("[CreateCommunity] error:", err);
      alert("⚠️ Сталася помилка при створенні спільноти");
    } finally {
      setIsUploading(false);
    }
  };

  const handleBackdropClick = () => {
    onClose?.();
  };

  return (
    <div className="create-community-page" onClick={handleBackdropClick}>
      <div className="ccp-backdrop" />

      <div
        className="ccp-shell"
        role="dialog"
        aria-modal="true"
      >
        <div className="ccp-header" onClick={(e) => e.stopPropagation()}>
          <h1>Створити спільноту</h1>
        </div>

        <div className="ccp-content" onClick={(e) => e.stopPropagation()}>
          <div className="ccp-avatar-wrapper">
            {preview ? (
              <img src={preview} alt="preview" className="ccp-avatar-img" />
            ) : (
              <div className="ccp-avatar-placeholder">Додати аватар</div>
            )}
            <label className="ccp-avatar-btn">
              Обрати файл
              <input type="file" accept="image/*" onChange={handleAvatarChange} />
            </label>
          </div>

          <div className="ccp-field">
            <label className="ccp-label">Назва спільноти</label>
            <input
              type="text"
              className="ccp-input"
              placeholder="Введіть назву спільноти"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="ccp-field">
            <label className="ccp-label">Опис спільноти</label>
            <textarea
              className="ccp-input ccp-area"
              placeholder="Короткий опис (до 160 символів)"
              maxLength={160}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <div className="ccp-counter">
              Залишилось {160 - description.length} символів
            </div>
          </div>

          <div className="ccp-actions">
            <button type="button" className="ccp-btn ghost" onClick={onClose}>
              Скасувати
            </button>
            <button
              type="button"
              className="ccp-btn primary"
              onClick={handleSubmit}
              disabled={isUploading}
            >
              {isUploading ? "Створюємо..." : "Створити"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCommunity;